export default {"src":"/_next/static/media/freshworks.a86c5c33.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};